"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSignInMessage = generateSignInMessage;
exports.generateNonce = generateNonce;
/**
 * Generates a Solana Sign-In message from the provided input
 * @param input The Sign-In parameters
 * @returns A formatted sign-in message string
 */
function generateSignInMessage(input) {
    // Default values for required fields
    var domain = input.domain || window.location.host;
    var nonce = input.nonce || generateNonce();
    var issuedAt = input.issuedAt || new Date().toISOString();
    var chainId = input.chainId || 'solana:mainnet';
    var statement = input.statement || 'Sign in with your Solana account';
    var version = input.version || '1';
    var uri = input.uri || window.location.href;
    // Build the message in the SIWS format
    var message = "".concat(domain, " wants you to sign in with your Solana account:\n");
    message += "\n";
    message += "".concat(statement, "\n");
    message += "\n";
    // Add URI, version and chain ID
    message += "URI: ".concat(uri, "\n");
    message += "Version: ".concat(version, "\n");
    message += "Chain ID: ".concat(chainId, "\n");
    // Add timestamps
    message += "Issued At: ".concat(issuedAt, "\n");
    if (input.expirationTime) {
        message += "Expiration Time: ".concat(input.expirationTime, "\n");
    }
    if (input.notBefore) {
        message += "Not Before: ".concat(input.notBefore, "\n");
    }
    // Add nonce for replay protection
    message += "Nonce: ".concat(nonce, "\n");
    // Add request ID if provided
    if (input.requestId) {
        message += "Request ID: ".concat(input.requestId, "\n");
    }
    // Add resources if provided
    if (input.resources && input.resources.length > 0) {
        message += "\n";
        message += "Resources:\n";
        for (var _i = 0, _a = input.resources; _i < _a.length; _i++) {
            var resource = _a[_i];
            message += "- ".concat(resource, "\n");
        }
    }
    return message;
}
/**
 * Generates a random nonce for sign-in requests
 * @returns A random string to use as a nonce
 */
function generateNonce() {
    // Generate a random string of 32 bytes, encoded as hex
    var bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return Array.from(bytes)
        .map(function (b) { return b.toString(16).padStart(2, '0'); })
        .join('');
}
